/* eslint-disable max-classes-per-file */
import { LitElement } from "lit"
import { state } from "lit/decorators.js"
import type { Ref } from "lit/directives/ref.js"
import { createRef } from "lit/directives/ref.js"
import { animation, NordEvent } from "../events.js"

type Constructor<T = Record<string, unknown>> = new (...args: any[]) => T

export declare class NotificationMixinInterface {
  protected dismissed: boolean
  protected notificationRef: Ref<HTMLElement>
  dismiss(): Promise<void>
}

export function NotificationMixin<T extends Constructor<LitElement>>(
  superClass: T
): Constructor<NotificationMixinInterface> & T {
  class NotificationElement extends superClass {
    protected notificationRef = createRef<HTMLElement>()

    @state() protected dismissed = false

    /**
     * Programmatically dismiss the notification.
     * The returned promise resolves when notification's exit animation is complete.
     */
    async dismiss() {
      if (this.notificationRef.value) {
        this.dismissed = true
        await animation(this.notificationRef.value)
        this.dispatchEvent(new NordEvent("dismiss"))
      }
    }
  }

  return NotificationElement as unknown as Constructor<NotificationMixinInterface> & T
}
